import React from 'react';

interface VoltageSourceProps {
  value?: number; // Kept for interface compatibility but not used for display
  label?: string; // Kept for compatibility
  x: number;
  y: number;
  rotation?: number;
  size?: number;
}

export const VoltageSource: React.FC<VoltageSourceProps> = ({
  x,
  y,
  rotation = 0,
  size = 40
}) => {
  const radius = size / 2;

  // Horizontal (0 deg) = Left(-x) to Right(+x)
  // Terminals: (-radius-10, 0) and (radius+10, 0)

  return (
    <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
      {/* Connector lines (Horizontal) */}
      <line x1={-radius - 10} y1={0} x2={-radius} y2={0} stroke="#1a1a1a" strokeWidth="2" />
      <line x1={radius} y1={0} x2={radius + 10} y2={0} stroke="#1a1a1a" strokeWidth="2" />

      {/* Source Circle */}
      <circle cx={0} cy={0} r={radius} stroke="#374151" strokeWidth="2" fill="white" />

      {/* Polarity signs (Inside) */}
      <text x={-radius / 2} y={1} textAnchor="middle" dominantBaseline="middle" fontSize="16" fill="#374151" style={{ pointerEvents: 'none' }}>-</text>
      <text x={radius / 2} y={1} textAnchor="middle" dominantBaseline="middle" fontSize="14" fill="#374151" style={{ pointerEvents: 'none' }}>+</text>

      {/* NO Internal Label Rendering */}
    </g>
  );
};
